import { create } from 'zustand'

export interface AIMessage {
  id: string
  role: 'user' | 'assistant'
  content: string
  timestamp: Date
}

interface AIAgentContext {
  dealId?: string
  module?: string
}

interface AIAgentState {
  isOpen: boolean
  toggleOpen: () => void
  setOpen: (open: boolean) => void

  isMinimized: boolean
  toggleMinimize: () => void
  setMinimized: (min: boolean) => void

  isDocked: boolean
  toggleDock: () => void

  messages: AIMessage[]
  addMessage: (msg: Omit<AIMessage, 'id' | 'timestamp'>) => string
  updateLastMessage: (content: string) => void
  appendToLastMessage: (delta: string) => void
  clearMessages: () => void

  context: AIAgentContext
  setContext: (ctx: AIAgentContext) => void

  inputValue: string
  setInputValue: (v: string) => void

  isTyping: boolean
  setIsTyping: (v: boolean) => void
}

const WELCOME_MESSAGES: AIMessage[] = [
  {
    id: 'welcome-1',
    role: 'assistant',
    content: `Welcome to **Helios AI**. Ask about CRE financing, CMBS, underwriting concepts, covenants, or how to use the platform.

Replies are generated by the API using Anthropic Claude when \`ANTHROPIC_API_KEY\` is set on the server. Verify anything material against your own data and policies.`,
    timestamp: new Date(),
  },
]

let messageCounter = 100

export const useAIAgentStore = create<AIAgentState>((set) => ({
  isOpen: false,
  toggleOpen: () => set((s) => ({ isOpen: !s.isOpen, isMinimized: false })),
  setOpen: (isOpen) => set({ isOpen, isMinimized: false }),

  isMinimized: false,
  toggleMinimize: () => set((s) => ({ isMinimized: !s.isMinimized })),
  setMinimized: (isMinimized) => set({ isMinimized }),

  isDocked: false,
  toggleDock: () => set((s) => ({ isDocked: !s.isDocked })),

  messages: WELCOME_MESSAGES,
  addMessage: (msg) => {
    const id = `msg-${++messageCounter}`
    set((s) => ({
      messages: [
        ...s.messages,
        { ...msg, id, timestamp: new Date() },
      ],
    }))
    return id
  },
  updateLastMessage: (content) =>
    set((s) => {
      const msgs = [...s.messages]
      if (msgs.length > 0) msgs[msgs.length - 1] = { ...msgs[msgs.length - 1], content }
      return { messages: msgs }
    }),
  appendToLastMessage: (delta) =>
    set((s) => {
      const msgs = [...s.messages]
      if (msgs.length > 0) msgs[msgs.length - 1] = { ...msgs[msgs.length - 1], content: msgs[msgs.length - 1].content + delta }
      return { messages: msgs }
    }),
  clearMessages: () => set({ messages: WELCOME_MESSAGES }),

  context: {},
  setContext: (context) => set({ context }),

  inputValue: '',
  setInputValue: (inputValue) => set({ inputValue }),

  isTyping: false,
  setIsTyping: (isTyping) => set({ isTyping }),
}))
